/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DentalToothSurface from './dental-tooth-surface';
import DentalToothSurfaceDetail from './dental-tooth-surface-detail';
import DentalToothSurfaceUpdate from './dental-tooth-surface-update';
import DentalToothSurfaceDeleteDialog from './dental-tooth-surface-delete-dialog';

const DentalToothSurfaceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DentalToothSurface />} />
    <Route path="new" element={<DentalToothSurfaceUpdate />} />
    <Route path=":id">
      <Route index element={<DentalToothSurfaceDetail />} />
      <Route path="edit" element={<DentalToothSurfaceUpdate />} />
      <Route path="delete" element={<DentalToothSurfaceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DentalToothSurfaceRoutes;
